import { action, computed, observable } from 'mobx';
import { NavbarConfig, NavbarMenuItem } from '@vtblife/layout-config/types';

import { RootStore } from './root';

export class NavbarStore {
    rootStore: RootStore;
    @observable private navbar?: NavbarConfig;

    constructor(rootStore: RootStore, initialState?: InitialState['navbarStore']) {
        this.rootStore = rootStore;
        if (initialState) {
            this.setInitialState(initialState);
        }
    }

    setInitialState(initialState: InitialState['navbarStore']) {
        Object.assign(this, initialState);
    }

    @computed get isInitialized() {
        return Boolean(this.navbar);
    }

    @action
    setNavbar(navbar?: NavbarConfig) {
        this.navbar = navbar;
    }

    @computed
    get menuItems(): Record<string, NavbarMenuItem[]> {
        return this.navbar?.menuItems || {};
    }

    @computed
    get currentMenuItems(): NavbarMenuItem[] {
        const currentRoleType = this.rootStore.userStore.currentRoleType || '';
        return this.menuItems[currentRoleType] || [];
    }

    @computed
    get shouldShowNavbar(): boolean {
        return this.currentMenuItems.length > 0;
    }
}
